module.exports = __webpack_public_path__ + "img/LimitBee-3.34c455ee.png";